import { render, staticRenderFns } from "./accountRecords.vue?vue&type=template&id=5c02efc1&scoped=true&"
import script from "./accountRecords.vue?vue&type=script&lang=js&"
export * from "./accountRecords.vue?vue&type=script&lang=js&"
import style0 from "./accountRecords.vue?vue&type=style&index=0&id=5c02efc1&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c02efc1",
  null
  
)

export default component.exports